import { QuizQuestion } from '../../api/quiz-services';

export const assessmentMetadata = {
    title: "Module 7 Quiz",
    duration: 15
};

export const module7Questions: QuizQuestion[] = [
    {
        id: "M7-001",
        moduleId: "module-7",
        category: "Vehicle Emergencies",
        text: "If your engine stalls while you are driving, what is the first mechanical override action you should take?",
        options: ["Shift the transmission to Neutral (N)", "Slam the brakes immediately", "Turn off the ignition switch", "Shift the transmission to Park (P)"],
        correctAnswer: 0,
        scenario: "You are traveling at highway speeds when your engine suddenly stalls, causing your power steering and brakes to feel extremely heavy. What is your first action?",
        explanation: "Shifting to Neutral (N) immediately disconnects the transmission from the stalled engine, allowing you to safely steer and coast the vehicle to the shoulder while keeping the wheels rolling."
    },
    {
        id: "M7-002",
        moduleId: "module-7",
        category: "Vehicle Emergencies",
        text: "If your accelerator pedal becomes stuck and your vehicle continues to deliver maximum power, you should instantly:",
        options: ["Turn off the engine key immediately", "Shift to Neutral (N) to cut power to the wheels", "Apply the emergency brake with maximum force", "Pump the brake pedal rapidly"],
        correctAnswer: 1,
        scenario: "Your accelerator pedal becomes physically stuck to the floor, and your engine continues to deliver maximum, runaway power on the highway. How do you recover?",
        explanation: "Instantly shift the transmission to Neutral (N). This cuts power to the drive wheels, allowing you to brake safely and steer to the shoulder without the engine accelerating the vehicle's mass."
    },
    {
        id: "M7-003",
        moduleId: "module-7",
        category: "Vehicle Emergencies",
        text: "If your brake pedal sinks to the floor and you experience total hydraulic brake failure, what is the first recovery step?",
        options: ["Steer toward a rigid utility pole to stop", "Engage the parking brake with maximum force", "Rapidly pump the brake pedal to build hydraulic pressure", "Turn off the ignition to lock the steering column"],
        correctAnswer: 2,
        scenario: "You press the service brake pedal, and it sinks completely soft and useless to the floor, indicating total hydraulic brake failure. How do you slow down?",
        explanation: "Rapidly pump the brake pedal. This can build enough residual hydraulic pressure in the dual-circuit brake cylinder to slow the vehicle down, allowing you to safely steer and use the parking brake."
    },
    {
        id: "M7-004",
        moduleId: "module-7",
        category: "Vehicle Emergencies",
        text: "If a high-voltage power line falls on your vehicle and you must evacuate due to a fire, how should you exit?",
        options: ["Step out normally, keeping one foot on the car and one on the ground", "Jump clear of the vehicle with both feet together and hop or shuffle away", "Climb onto the roof and jump as far as possible", "Wait for someone to walk up and help you out"],
        correctAnswer: 1,
        scenario: "A high-voltage power line falls across your hood after a collision, and the vehicle begins to catch fire. How must you escape safely?",
        explanation: "Jump completely clear without touching the car and the ground simultaneously (which would complete the electrical path). Land with both feet together and hop or shuffle away, keeping your feet close."
    },
    {
        id: "M7-005",
        moduleId: "module-7",
        category: "Vehicle Emergencies",
        text: "If your engine temperature gauge spikes into the red zone, turning on the cabin heater helps by:",
        options: ["Increasing passenger comfort", "Drawing extreme heat away from the engine block", "Bypassing the thermostat entirely", "Increasing coolant flow speed"],
        correctAnswer: 1,
        scenario: "Your engine temperature gauge spikes into the red zone and steam begins to rise from the hood. How can you draw heat away from the block in an emergency?",
        explanation: "Turning on your cabin heater to maximum blower and temperature acts as a secondary radiator, drawing extreme heat away from the engine block into the passenger cabin to prevent engine seizure."
    },
    {
        id: "M7-006",
        moduleId: "module-7",
        category: "Driver Emergencies",
        text: "If two of your wheels drop off the paved road onto a gravel shoulder, you should immediately:",
        options: ["Jerk the wheel sharply to climb back onto the pavement", "Slam the brakes to stop as fast as possible", "Grip the wheel firmly, ease off the gas, and straddle the pavement edge", "Shift to Neutral and coast to a stop"],
        correctAnswer: 2,
        scenario: "Your right-side tires drop off the paved road onto a low, gravel shoulder at high speed. What is your immediate reaction?",
        explanation: "Grip the steering wheel firmly to resist lateral pull, ease off the gas, and straddle the pavement edge. Slow down to a safe speed (< 25 mph) before attempting a controlled steering recovery."
    },
    {
        id: "M7-007",
        moduleId: "module-7",
        category: "Driver Emergencies",
        text: "To safely return to the pavement after a shoulder drop, what is the correct steering sequence once you have slowed down?",
        options: ["Turn the wheel gently at a shallow angle", "Make a crisp quarter-turn steer, then immediately counter-steer to align", "Hold the wheel straight and accelerate hard", "Jerk the wheel back and forth rapidly"],
        correctAnswer: 1,
        scenario: "",
        explanation: ""
    },
    {
        id: "M7-008",
        moduleId: "module-7",
        category: "Driver Emergencies",
        text: "An understeer skid occurs when the front tires lose traction. To recover, you should:",
        options: ["Slam on the brakes to force weight forward", "Ease off the accelerator, do not brake, and keep the wheels pointed along the curve", "Turn the wheel sharply in the opposite direction", "Accelerate hard to power out of the slide"],
        correctAnswer: 1,
        scenario: "You steer into a sharp highway curve, but the front wheels lose traction and the vehicle slides straight toward the guardrail. How do you recover?",
        explanation: "In an understeer skid (loss of front tire traction), ease off the gas. Do not slam the brakes, as this locks the tires further. Keep your wheels pointed in your intended direction until grip returns."
    },
    {
        id: "M7-009",
        moduleId: "module-7",
        category: "Driver Emergencies",
        text: "An oversteer skid (rear-wheel slide or fishtail) occurs when the rear tires lose traction. To recover, steer:",
        options: ["In the opposite direction of the skid", "Directly toward the ditch", "In the direction you want the front of the vehicle to go", "Lock the wheel to the far left or right"],
        correctAnswer: 2,
        scenario: "The rear wheels of your vehicle lose lateral traction on a wet curve and the tail begins to swing out (fishtail). How do you steer?",
        explanation: "In an oversteer skid (loss of rear tire traction), steer in the direction you want the front of the car to go. If the tail slides right, steer right. This counter-steer aligns the suspension."
    },
    {
        id: "M7-010",
        moduleId: "module-7",
        category: "Driver Emergencies",
        text: "To override hazard fixation during a skid and guide the vehicle safely, you must biologically:",
        options: ["Look directly at the obstacle you want to avoid", "Look down at the pedals to verify foot placement", "Look where you want the vehicle to go, guiding your hands naturally", "Close your eyes to prevent panic"],
        correctAnswer: 2,
        scenario: "Your vehicle goes into a high-speed spin on an icy highway, and you notice a large utility pole directly in your slide path. Where must you look?",
        explanation: "You must biologically force your gaze away from the hazard (pole) and look directly at your open target escape path. Your hands naturally follow your eyes, guiding the steering wheels."
    },
    {
        id: "M7-011",
        moduleId: "module-7",
        category: "Collision Reporting",
        text: "When executing an emergency stop in a vehicle equipped with an Anti-Lock Braking System (ABS), you should:",
        options: ["Pump the brake pedal rapidly to prevent wheel lockup", "Stomp the brake pedal down fully and hold it, expecting chattering", "Squeeze the pedal gently to maintain rolling traction", "Engage the parking brake simultaneously"],
        correctAnswer: 1,
        scenario: "You must execute an emergency stop on a wet highway in a vehicle equipped with certified Anti-lock Brakes (ABS). What is the protocol?",
        explanation: "Stomp the pedal down fully and maintain continuous, maximum pressure. Expect mechanical noise and vibration (chattering). Never pump the brakes, as this deactivates the automatic system."
    },
    {
        id: "M7-012",
        moduleId: "module-7",
        category: "Collision Reporting",
        text: "When executing an emergency stop in a vehicle WITHOUT Anti-Lock Brakes (Non-ABS), you should:",
        options: ["Stomp the brake pedal as hard as possible and keep it locked", "Pump the brake pedal rapidly between 0% and 100%", "Squeeze the pedal firmly to slow rapidly without locking the wheels", "Avoid using the brake pedal and downshift only"],
        correctAnswer: 2,
        scenario: "You must execute an emergency stop on a wet road in an older vehicle WITHOUT Anti-lock Brakes (Non-ABS). How do you brake?",
        explanation: "Practice threshold braking by squeezing the pedal firmly up to the point of lockup, then easing off slightly to keep the tires rolling, allowing you to maintain steering control."
    },
    {
        id: "M7-013",
        moduleId: "module-7",
        category: "Collision Reporting",
        text: "In Ohio, you are legally required to report a motor vehicle collision to law enforcement immediately if it results in injury, death, or property damage exceeding:",
        options: ["$100", "$500", "$1,000", "$5,000"],
        correctAnswer: 2,
        scenario: "You are involved in a collision in Ohio. No one is injured, but both vehicles suffer body damage. When are you legally required to report it?",
        explanation: "Under Ohio Revised Code, you must report any motor vehicle collision to law enforcement immediately if it results in injury, death, or cumulative property damage exceeding $1,000."
    },
    {
        id: "M7-014",
        moduleId: "module-7",
        category: "Collision Reporting",
        text: "If you strike an unattended parked vehicle and cannot locate the owner, you must:",
        options: ["Drive away immediately to clear the roadway", "Leave a visible note with your name and contact details, and report it to the police within 24 hours", "Wait at the vehicle for up to 48 hours", "Call a tow truck to remove the vehicle"],
        correctAnswer: 1,
        scenario: "You lose traction in a parking lot and strike an unattended parked vehicle. You cannot locate the owner in the nearby store. What must you do?",
        explanation: "You are legally mandated to leave a visible note containing your name, contact details, and insurance information on the vehicle, and report the accident to the police within 24 hours."
    },
    {
        id: "M7-015",
        moduleId: "module-7",
        category: "Collision Reporting",
        text: "Failing to stop and exchange information at the scene of a collision (hit-and-run) is classified in Ohio as:",
        options: ["A minor traffic infraction with no points", "A severe criminal offense resulting in mandatory license suspension and potential jail time", "An administrative warning with a small fine", "A civil matter handled solely by insurance companies"],
        correctAnswer: 1,
        scenario: "A driver scrapes a guardrail and minorly dents another car's door. They decide to drive away without exchanging info to avoid insurance spikes.",
        explanation: "Leaving the scene of an accident (hit-and-run) is a high-priority criminal offense in Ohio, carrying mandatory license suspension, heavy points, and potential jail sentences."
    },
    {
        id: "M7-016",
        moduleId: "module-7",
        category: "Post-Collision Responsibilities",
        text: "Immediately following a collision, what is the first priority to stabilize the scene?",
        options: ["Exchange insurance information with the other driver", "Turn on hazard flashers, check on occupants, and prevent a second collision", "Take close-up photos of all vehicle scratches", "Call your insurance agent immediately"],
        correctAnswer: 1,
        scenario: "",
        explanation: ""
    },
    {
        id: "M7-017",
        moduleId: "module-7",
        category: "Post-Collision Responsibilities",
        text: "When assisting an injured occupant at a crash scene, you should NEVER move them unless:",
        options: ["They request to sit on the shoulder", "You need to clear the roadway for traffic", "There is an immediate threat of fire or explosion", "The police officer instructs you to do so before medical arrival"],
        correctAnswer: 2,
        scenario: "You arrive at a crash scene and notice an unconscious occupant inside a damaged vehicle. Under what condition should you move them?",
        explanation: "Never move an injured occupant unless there is an immediate, life-threatening danger (like vehicle fire or water submersion), as moving them can worsen spinal cord injuries."
    },
    {
        id: "M7-018",
        moduleId: "module-7",
        category: "Post-Collision Responsibilities",
        text: "The Ohio Good Samaritan Act (ORC 2305.23) legally protects individuals from civil liability when they:",
        options: ["Accidentally cause a crash while driving", "Provide emergency medical care or assistance in good faith at a crash scene", "Refuse to pay their auto insurance premiums", "Flee the scene of a minor fender-bender"],
        correctAnswer: 1,
        scenario: "You provide CPR and first aid to a crash victim in good faith at an emergency scene. Can you be sued if they suffer complications?",
        explanation: "The Ohio Good Samaritan Act (ORC 2305.23) legally shields you from civil liability when providing emergency medical care or assistance in good faith at an accident scene."
    },
    {
        id: "M7-019",
        moduleId: "module-7",
        category: "Post-Collision Responsibilities",
        text: "When taking photographs to document a collision scene for legal and insurance purposes, you should focus on:",
        options: ["Only close-ups of your own vehicle's damage", "Wide-angle context photos showing vehicle final positions relative to road markings and signs, close-up damage, and skid marks", "Selfies to prove your presence at the scene", "Only the other driver's license plate"],
        correctAnswer: 1,
        scenario: "You are involved in a collision and want to take photographs for legal and insurance documentation. What is your visual target?",
        explanation: "Take wide-angle context photos showing vehicle final positions relative to road markings, signs, and skid marks, followed by close-ups of body damage and license plates."
    },
    {
        id: "M7-020",
        moduleId: "module-7",
        category: "Post-Collision Responsibilities",
        text: "During post-crash police investigation, the most legally and factually secure communication strategy is to:",
        options: [
            "Apologize repeatedly to the other driver to show politeness",
            "Admit fault immediately to speed up the process",
            "State only direct, objective facts to the investigating officer, avoiding speculation or admissions",
            "Refuse to speak to anyone until your lawyer arrives"
        ],
        correctAnswer: 2,
        scenario: "An officer asks you to explain the sequence of a collision. What is the most legally and factually secure communication strategy?",
        explanation: "State only objective, observable facts (e.g. 'I was stopped when the vehicle struck me'). Avoid speculation, emotional admissions, or signing statements before consulting legal counsel."
    },
    {
        id: "M7-021",
        moduleId: "module-7",
        category: "Emergency",
        text: "If your accelerator pedal gets stuck down while driving on a highway, what should you do first?",
        options: [
            "Slam on the parking brake immediately",
            "Turn off the ignition key, locking the steering wheel",
            "Shift the transmission into Neutral (N) and apply firm, steady braking",
            "Floor the accelerator pedal harder"
        ],
        correctAnswer: 2,
        scenario: "**Correct Action**: **If your pedal stick, immediately shift into Neutral (N) to disconnect engine power from the drive wheels, then apply firm, steady braking to pull over. Turning off the key immediately can lock your steering wheel.**",
        explanation: ""
    },
    {
        id: "M7-022",
        moduleId: "module-7",
        category: "Emergency",
        text: "If a front tire blows out at high speed, how should you steer and handle the vehicle?",
        options: [
            "Slam the brakes and turn the steering wheel sharply",
            "Grip the wheel firmly, ease off the gas, steer straight, and brake gently once the vehicle is under control",
            "Shift to Reverse immediately",
            "Sound your horn repeatedly and swerve to the left shoulder"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **During a tire blowout, grip the steering wheel firmly with both hands, steer straight, and ease off the accelerator. Do not slam the brakes; wait for the vehicle to slow down naturally before braking gently.**",
        explanation: ""
    },
    {
        id: "M7-023",
        moduleId: "module-7",
        category: "Emergency",
        text: "If your brakes fail completely, what is the best sequence to safely slow down?",
        options: [
            "Turn the car off immediately",
            "Pump the brake pedal, shift to a lower gear, and use the parking brake gently to slow down without locking the wheels",
            "Swerve side-to-side into oncoming traffic",
            "Steer directly into a solid concrete barrier at high speed"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **If brakes fail completely, pump the pedal rapidly (to build pressure), shift to a lower gear to let the engine slow you down, and gently apply the parking brake without locking the wheels.**",
        explanation: ""
    },
    {
        id: "M7-024",
        moduleId: "module-7",
        category: "Duty",
        text: "Under Ohio law, what must a driver do immediately when an emergency vehicle with flashing lights or sirens approaches from behind?",
        options: [
            "Speed up to stay ahead of it",
            "Stop in your current lane immediately",
            "Pull over safely to the right-hand edge of the road and stop until it has passed",
            "Turn on your hazard lights and continue driving normally"
        ],
        correctAnswer: 2,
        scenario: "**Correct Action**: **Ohio law requires all motorists to immediately pull over to the right edge of the road and stop until the approaching emergency vehicle with sirens or flashing lights has fully passed.**",
        explanation: ""
    },
    {
        id: "M7-025",
        moduleId: "module-7",
        category: "Duty",
        text: "What is Ohio's 'Move Over Law' requirement when approaching stationary emergency or utility vehicles on the roadside?",
        options: [
            "Honk your horn and maintain your speed",
            "Reduce speed and, if safe and possible, move over at least one lane away from the stationary emergency vehicle",
            "Turn on high beams",
            "Speed up to clear the area"
        ],
        correctAnswer: 1,
        scenario: "**Correct Action**: **Ohio\\'s Move Over Law mandates that drivers approaching a stopped emergency, utility, or construction vehicle must slow down and, if safe and possible, move over at least one lane away from the roadside vehicle.**",
        explanation: ""
    }
];
